// store/EmployeeStore.js
import { makeAutoObservable, runInAction } from 'mobx';

// Backend API URL from environment variable
const API_URL = process.env.REACT_APP_API_URL || 'https://bitrixapi.tmg-din-reestr.ru';

class EmployeeStore {
  employees = [];
  loading = false;
  user = null;
  auth = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Set user and auth
  setUser(user) {
    this.user = user;
  }

  setAuth(auth) {
    this.auth = auth;
  }

  // Get employee by ID
  getEmployeeById(id) {
    return this.employees.find((obj) => Number(obj.id) === Number(id));
  }

  // Fetch employees list
  async fetchEmployees({ user = this.user, auth = this.auth } = {}) {
    if (!user || !auth) {
      console.warn('No auth or user for backend request');
      return;
    }

    this.loading = true;
    try {
      const res = await fetch(`${API_URL}/employees`, {
        headers: {
          'X-Bitrix-User': user,
          'X-Bitrix-Auth': auth,
        },
      });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const data = await res.json();

      runInAction(() => {
        this.employees = data.map((user) => ({
          id: Number(user.ID ?? user.id),
          xmlId: user.XML_ID,
          name: `${user.LAST_NAME ?? ''} ${user.NAME ?? user.name}`.trim(),
          email: user.EMAIL,
          workPosition: user.WORK_POSITION,
        }));
      });
    } catch (error) {
      console.error('Ошибка при загрузке сотрудников:', error);
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  // ===========================
  // New method: search by name
  // ===========================
  normalize(str) {
    return String(str ?? '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  /**
   * Search for employee by first/last name.
   * Can input "First Last", "Last First", case insensitive.
   * Returns id of first match or null.
   */
  findEmployeeIdByName(input) {
    const normInput = this.normalize(input);

    for (const emp of this.employees) {
      const normName = this.normalize(emp.name); // "Ivanov Ivan"
      const [last, first] = normName.split(' '); // assume "Last First"

      const combos = [
        `${first} ${last}`, // "First Last"
        `${last} ${first}`, // "Last First"
        `${first}`,         // first name only
        `${last}`,          // last name only
        normName,           // full "Last First"
      ];
      //console.log(combos, last, first)
      if (combos.some(c => {console.log(combos, normInput); return c === normInput})) {
        console.log('found', normInput, emp.id)
        return emp.id;
      }
    }

    return null; // not found
  }
}

const employeeStore = new EmployeeStore();
export default employeeStore;
